import errorDecorator from "@/components/fields/errors";

export default {
  mixins: [errorDecorator],

  data() {
    return {
      form: {},
      fields: [
        {
          key: "firstName",
          type: "input",
          templateOptions: {
            label: "First Name"
          },
          required: true
        },
        {
          key: "lastName",
          type: "input",
          templateOptions: {
            label: "Last Name"
          },
          required: true
        },
        {
          key: "email",
          type: "input",
          templateOptions: {
            label: "email",
            inputType: "email"
          },
          required: true
        },
        {
          key: "phone",
          type: "input",
          templateOptions: {
            label: "Phone",
            inputType: "tel"
          },
          required: true
        },
        {
          key: "password",
          type: "input",
          templateOptions: {
            label: "Password to encrypt/decrypt referral PDF",
            inputType: "password"
          },
          required: true
        }
      ]
    };
  }
};
